export default "__VITE_ASSET__BfF0bRq1__"